import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EmailService {

  constructor(private http:HttpClient) { }

  sendMail(properties:any) {
    return this.http.post(`${environment.apiBaseUrl}/email`, properties);
  }
}
